import { useRef, useCallback, useState } from "react";
import Translate from "../../utils/Translate";
import SpeedMenu from "../../components/SpeedMenu";
import JobQueueView from "../../components/admin/bgjobs/JobQueueView";
import EnqueueJobDialog from "../../components/admin/bgjobs/EnqueueJobDialog";
import AddIcon from "@mui/icons-material/Add";
import { useApi } from "../../utils/Api";

export default function BackgroundJobsPage() {
  const [queueData, setQueueData] = useState(null);
  const [loadingQueueData, setLoadingQueueData] = useState(false);
  const api = useApi();

  const reloadQueueData = useCallback(async () => {
    setLoadingQueueData(true);
    const response = await api.fetch(`${import.meta.env.VITE_BGJOBS_URL}bgjobs/queue`, false, "GET");
    if (response.isSuccessful) {
      setQueueData(response);
    }
    setLoadingQueueData(false);
  }, [api]);

  const handleEnqueued = useCallback(() => {
    reloadQueueData();
  }, []);

  const speedMenuContent = [
    {
      icon: <AddIcon />,
      text: Translate.get("EnqueueJob"),
      route: false,
      dialogHeader: Translate.get("EnqueueJob"),
      component: <EnqueueJobDialog onEnqueued={handleEnqueued} />,
    },
  ];

  return (
    <>
      <JobQueueView queueData={queueData} loadingQueueData={loadingQueueData} reloadQueueData={reloadQueueData} />
      <SpeedMenu content={speedMenuContent} />
    </>
  );
}
